import { FiltersInterface } from "../../../../Global/Interfaces/GlobalInterfaces";

export default class PrivateLeagueFilters implements FiltersInterface {
  public limit?: number = null;
  public page?: number = null;
  public leagueId?: string = null;
  public templateId?: string = null;
  public sortOrder?: string = null;

  constructor(filters: any) {
    this.limit = filters && filters.limit ? filters.limit : null;
    this.page = filters && filters.page ? filters.page : null;
    this.leagueId = filters && filters.leagueId ? filters.leagueId : null;
    this.templateId = filters && filters.templateId ? filters.templateId : null;
    this.sortOrder = filters && filters.sortOrder ? filters.sortOrder : null;
  }

  constructFiltersUrl? = () => {
    let url = "";

    if (this.limit) {
      url += `&limit=${this.limit}`;
    }

    if (this.page) {
      url += `&page=${this.page}`;
    }

    if (this.leagueId) {
      url += `&private_league_id=${this.leagueId}`;
    }

    if (this.templateId) {
      url += `&template_id=${this.templateId}`;
    }

    if (this.sortOrder) {
      url += `&sort_order=${this.sortOrder}`;
    }

    return url;
  };
}
